/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Permissions_TitleInputs */



/**
* | output |
* | --- |
* | "Guide Permissions" |
*
* @param {Knp_Manager_Permissions_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_permissions_title = /** @type {((inputs?: Knp_Manager_Permissions_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Permissions_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autorisations du guide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Leitfadenberechtigungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Autorizzazioni della guida")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Руководство по правам доступа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Permisos de guía")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向导权限")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ガイドの権限")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गाइड अनुमतियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Permissões do guia")
	return /** @type {LocalizedString} */ ("Guide Permissions")
});